import React from 'react';
import { styled } from '@compiled/react';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useShowStatuses } from '@atlassian/jira-software-view-settings/src/controllers/index.tsx';
import { useBacklogSelector } from '../../../../../state';
import { isUserAtLeastMemberOfProject } from '../../../../../state/selectors/config';
import {
	getLabelWidthMultiplier,
	LabelType,
} from '../../../card/card-contents/utils/responsive-labels';
import type { ScreenSize } from '../../../hooks/common/constants';
import { StatusLite } from '../index';

type Props = {
	cardKey: string;
	backlogContainerSize: ScreenSize | undefined;
};

export const Status = ({ cardKey, backlogContainerSize }: Props) => {
	const isUserAtLeastMember = useBacklogSelector(isUserAtLeastMemberOfProject);
	const showStatuses = useShowStatuses();

	return showStatuses ? (
		<StatusContainer
			widthMultiplier={getLabelWidthMultiplier(LabelType.STATUS, backlogContainerSize)}
		>
			<StatusLite isUserAtLeastMember={isUserAtLeastMember} issueKey={cardKey} />
		</StatusContainer>
	) : null;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StatusContainer = styled.div<{ widthMultiplier: number }>({
	display: 'grid',
	height: '24px',
	pointerEvents: 'none',
	overflow: 'inherit',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	gridTemplateColumns: ({ widthMultiplier }) =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		`repeat(auto-fit,${gridSize * widthMultiplier}px)`,
});
